export default {
  messageCenter: {
    addAttachments: 103053, // Add Attachments
    areYouSureWantToDeleteMessage: 102145, // Are you sure want to delete message?
    areYouSureYouWantToCancelTheSendingOf: 102161, // Are you sure you want to cancel the sending of this message?
    areYouSureYouWantToDeleteTheseMessages: 102158, // Are you sure you want to delete these messages?
    areYouSureYouWantToRemoveName: 103055, // Are you sure you want to remove {name}?
    cancelSendingMessage: 102159, // Cancel Sending Message
    deleteMessages: 102156, // Delete Messages
    departments: 28026, // Departments
    forward: 83119, // Forward
    from: 45645, // From
    inbox: 83112, // Inbox
    markAllAsRead: 102155, // Mark All as Read
    markAllAsUnread: 102154, // Mark All as Unread
    markAsUnread: 83122, // Mark as Unread
    message: 63132, // Message
    messageCenter: 83129, // Message Center
    newMessage: 102162, // New Message
    removeAttachments: 103054, // Remove Attachments
    reply: 83120, // Reply
    replyToAll: 83121, // Reply To All
    search: 81319, // Search
    searchInMessage: 102147, // Search in message
    selectAMessageYouWantToViewOrCreateA: 102142, // Select a message you want to view or create a new one
    selectRecipients: 102146, // Select recipients
    send: 83126, // Send
    sender: 102148, // Sender
    sent: 102153, // Sent
    showingFromtoOfTotalMessages: 102171, // Showing {from}-{to} of {total} messages
    teams: 101794, // Teams
    to: 46184, // To
    unread: 102152, // Unread
    uploadUpToMaxfilesFiles: 103057, // Upload up to {maxFiles} files
    youAreCancelingAMessage: 102160, // You are canceling a message
    youAreDeletingNumberMessageS: 102157, // You are deleting {number} message(s)
    youCanUploadUpToMaxfilesFilesOnly: 103056, // You can upload up to {maxFiles} files only
    youHaveSuccessfullyDeletedMessage: 102144, // You have successfully deleted message
    youHaveSuccessfullyDeletedNumberMessageS: 102151, // You have successfully deleted {number} message(s)
    youHaveSuccessfullyMarkedMessageUnread: 102143, // You have successfully marked message unread
    youHaveSuccessfullyMarkedNumberMessageSRead: 102149, // You have successfully marked {number} message(s) read
    youHaveSuccessfullyMarkedNumberMessageSUnread: 102150, // You have successfully marked {number} message(s) unread
    youHaveSuccessfullySentAMessage: 102141, // You have successfully sent a message
  },
};
